import { useCallback } from 'react';
import { useAppAuthActions } from '@/hooks/useAppAuth';
import AuthService from '@/services/auth.service';

/**
 * Sign out, by whichever mechanism this tenant authenticates with.
 *
 * Shared between the desktop sidebar menu and the mobile home screen. The two
 * paths differ by more than a redirect — OIDC needs its own logout URL hit so
 * the cookie and the Redis session are cleared server-side, and Frontegg needs
 * its refresh cookie invalidated — so this is not something to reimplement at
 * each call site.
 */
export function useLogout() {
  const { logout } = useAppAuthActions();

  return useCallback(() => {
    const authService = AuthService.getInstance();
    sessionStorage.removeItem('plb_auth_state');

    if (authService.oidcEnabled) {
      // OIDC: redirect to /oidc/logout which clears cookie + Redis session
      authService.handoffToken = null;
      authService.plbAuthState = null;
      if (authService.oidcLogoutUrl) {
        window.location.href = authService.oidcLogoutUrl;
      } else {
        window.location.replace('/login');
      }
    } else {
      // Frontegg: invalidate refresh cookie, then redirect
      try { logout(); } catch (e) { /* */ }
      window.location.href = '/do/logout';
    }
  }, [logout]);
}
